<template>
    <div ref="root">
        <div
            class="gallery__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="gallery__inner module__inner">
                <div class="gallery__inner--main module__inner--main">
                    <div
                        class="gallery__slider module__slider"
                        v-if="items && Array.isArray(items) && items.length > 0"
                        ref="slider"
                        :active-border="[2].includes(module.layout.type)"
                        :autoplay="!['auto'].includes(module.data.type)"
                        :disable-dragging="items.length <= 1"
                        loop
                        v-bind:class="{ slider: true }"
                    >
                        <ul
                            class="gallery__slider-items module__slider-items"
                            v-bind:class="{
                                'module__slider-items--auto-height gallery__slider-items--auto-height': [
                                    'auto'
                                ].includes(module.data.type)
                            }"
                        >
                            <li
                                class="module__slider-item gallery__item flex--wrap"
                                :data-slide-id="image__value.id"
                                v-for="(image__value, image__key) in items"
                                v-bind:key="image__key"
                            >
                                <div
                                    v-if="
                                        image__value.data &&
                                            (image__value.data.title ||
                                                image__value.data.subtitle ||
                                                image__value.data.text ||
                                                image__value.data.link.active)
                                    "
                                    class="gallery__container-inner module__container-inner bg-color-gradient"
                                    v-bind:class="{
                                        'container__boxed--half': [1, 2, 3].includes(
                                            module.layout.type
                                        )
                                    }"
                                >
                                    <div
                                        class="gallery__inner-row module__inner-row"
                                        v-if="image__value.data.title || image__value.data.subtitle"
                                    >
                                        <div class="gallery__inner-col module__inner-col">
                                            <div class="gallery__header module__header">
                                                <h2
                                                    class="gallery__title module__title font-h2 font-bold color-h2"
                                                    v-if="image__value.data.title"
                                                    v-html="image__value.data.title"
                                                ></h2>
                                                <h3
                                                    class="gallery__subtitle module__subtitle font-h3 font-bold color-h2"
                                                    v-if="image__value.data.subtitle"
                                                    v-html="image__value.data.subtitle"
                                                ></h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="gallery__inner-row module__inner-row"
                                        v-if="image__value.data.text"
                                    >
                                        <div class="gallery__inner-col module__inner-col">
                                            <div
                                                class="gallery__text module__text font-p font-bold color-p module__cms"
                                                v-if="image__value.data.text"
                                                v-html="image__value.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="gallery__inner-row module__inner-row"
                                        v-if="
                                            (image__value.data.link &&
                                                image__value.data.link.active) ||
                                                (image__value.data.link2 &&
                                                    image__value.data.link2.active) ||
                                                (image__value.data.link3 &&
                                                    image__value.data.link3.active)
                                        "
                                    >
                                        <div class="gallery__inner-col module__inner-col">
                                            <div class="gallery__cta module__cta">
                                                <app-modulebutton
                                                    :data="image__value.data.link"
                                                    :custom-class="
                                                        'gallery__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    :data="image__value.data.link2"
                                                    :custom-class="
                                                        'gallery__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    :data="image__value.data.link3"
                                                    :custom-class="
                                                        'gallery__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="gallery__bg-image"
                                    v-if="
                                        image__value.data &&
                                            image__value.data.image &&
                                            image__value.data.image.id
                                    "
                                >
                                    <app-moduleimage
                                        :data="image__value.data.image"
                                        :tag="'div'"
                                        :is-blurred="true"
                                        :custom-class="'gallery__moduleimage module__moduleimage'"
                                    ></app-moduleimage>
                                    <app-moduleimage
                                        v-if="!['auto'].includes(module.data.type)"
                                        :data="image__value.data.image"
                                        :tag="'div'"
                                        :custom-class="'gallery__moduleimage module__moduleimage'"
                                    ></app-moduleimage>
                                    <app-moduleimage
                                        v-if="['auto'].includes(module.data.type)"
                                        :data="image__value.data.image"
                                        :tag="'img'"
                                        :img-opacity="true"
                                        :custom-class="'gallery__moduleimage module__moduleimage'"
                                    ></app-moduleimage>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    mixins: [SliderMixin],
    methods: {},
    computed: {
        ...mapGetters(['getPageUrlFromId']),
        items() {
            return toArray(this.module.data.slides)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        module: Object
    }
};
</script>
